export const ADD_POST = 'ADD_POST';
export const REMOVE_POST = 'REMOVE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const RESET_POSTS = 'RESET_POSTS';
export const SET_SELECTED_POST = 'SET_SELECTED_POST';
export const TOGGLE_POST_SELECTION = 'TOGGLE_POST_SELECTION';

export const SET_DEFAULT_COVER = 'SET_DEFAULT_COVER'
export const RESET_TO_DEFAULT_COVER = 'RESET_TO_DEFAULT_COVER'

export const RECEIVER_USER_DETAILS = 'RECEIVER_USER_DETAILS';
export const RECEIVER_CHOOSED_PLATEFORM = 'RECEIVER_CHOOSED_PLATEFORM';
export const IS_USER_WANT_DESIGN_GIFTCARD = 'IS_USER_WANT_DESIGN_GIFTCARD';
export const SHOW_GIFT_DESIGN_PANEL = 'SHOW_GIFT_DESIGN_PANEL';
export const HIDE_GIFT_DESIGN_PANEL = 'HIDE_GIFT_DESIGN_PANEL';